import { ProgressIndicator, Stack } from '@fluentui/react';
import React, { Component } from 'react';

export class EUIProgressIndicator extends Component {

    static defaultProps = {
        id: "euiProgressIndicator",
        label: undefined,
    };

    render = () => {

        const styles = {
            stack: {
                root: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    inset: "0 0 0 0",
                    position: "fixed",
                    zIndex: 1000001, // L'overlay des Modals d'OUIF ont un z-index égal à 1000000
                }
            },
            progressIndicator: {
                itemName: { color: "white", textShadow: "0 0 10px black" },
                root: { width: "58%" }
            }
        };

        return <Stack id={this.props.id} horizontalAlign="center" verticalAlign="center" verticalFill styles={styles.stack}>
            <ProgressIndicator {...this.props} styles={styles.progressIndicator} />
        </Stack>;

    };
}